
import { useTranslation } from 'react-i18next';

export default function ServicesSection() {
  const { t } = useTranslation();

  const serviceCards = [
    {
      id: 1,
      icon: 'ri-truck-line',
      titleKey: 'services.freight.title',
      items: [
        'services.freight.item1',
        'services.freight.item2',
        'services.freight.item3',
        'services.freight.item4',
      ],
    },
    {
      id: 2,
      icon: 'ri-route-line',
      titleKey: 'services.logistics.title',
      items: [
        'services.logistics.item1',
        'services.logistics.item2',
        'services.logistics.item3',
        'services.logistics.item4',
      ],
    },
    {
      id: 3,
      icon: 'ri-shield-check-line',
      titleKey: 'services.commitment.title',
      items: [
        'services.commitment.item1',
        'services.commitment.item2',
        'services.commitment.item3',
        'services.commitment.item4',
      ],
    },
  ];

  return (
    <section id="services" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            {t('services.title')}
          </h2>
          <p className="text-lg text-gray-600 max-w-4xl mx-auto">
            {t('services.description')}
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {serviceCards.map((service) => (
            <div
              key={service.id}
              className="bg-gray-50 rounded-lg p-8 hover:shadow-lg transition-shadow duration-300"
            >
              <div className="w-16 h-16 flex items-center justify-center bg-orange-500 rounded-lg mb-6">
                <i className={`${service.icon} text-3xl text-white`}></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-4">
                {t(service.titleKey)}
              </h3>
              <ul className="space-y-3">
                {service.items.map((itemKey, index) => (
                  <li key={index} className="flex items-start">
                    <i className="ri-check-line text-orange-500 text-xl mr-2 flex-shrink-0"></i>
                    <span className="text-gray-600 text-sm">{t(itemKey)}</span>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
